module.exports = __webpack_public_path__ + "media/images/mosaic-636e551f1cefe6e77d6b99bdfb3a1324.jpg";